import { alpha, Grid, Stack, Theme, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { TFunction } from 'i18next';
import IconMi from 'components/common/icon/IconMi';
import { ButtonConfig, PopupMode, PopupType } from './index';
import CreateButton from './buttons/CreateButton';
import { PopupSettings } from 'components/common/popup/Popup';
import { TextDataFinalHtml } from 'tools/types';
import { FormRendererAPIType } from 'components/common/form';

export default function EmptyGrid({
    emptyTitle,
    emptyIcon,
    gridEntityType,
    createButtons,
    t,
    gridName,
    height,
    controllerUrl,
    gridPopup,
    setPopupGetMethod,
    setPopupComponent,
    setPopupComponentProps,
    setFormPostData,
    setPopupMode,
    setPopupRedirectAfter,
    setPopupUrl,
    setPopupType,
    setPopupConfig,
    form,
}: {
    emptyTitle: TextDataFinalHtml;
    emptyIcon?: string;
    gridEntityType?: string;
    createButtons: ButtonConfig[];
    controllerUrl: string;
    t: TFunction;
    gridName: string;
    height?: number; //is Page grid
    gridPopup: ReactElement;
    setPopupUrl?: (url: string) => void;
    setPopupConfig?: (popupConfig: PopupSettings) => void;
    setPopupType?: (type: PopupType) => void;
    setPopupMode?: (mode: PopupMode) => void;
    setPopupRedirectAfter?: (redirect: boolean) => void;
    setFormPostData?: (formData: any) => void;
    setPopupGetMethod?: (getMethod: boolean) => void;
    setPopupComponent?: (popupComponent: string) => void;
    setPopupComponentProps?: (popupComponentProps: { [key: string]: string }) => void;
    form?: FormRendererAPIType;
}) {
    const getCreateButtons = () => {
        if (createButtons.length > 0) {
            return createButtons.map((createButtonConfig) => {
                return (
                    <CreateButton
                        key={createButtonConfig.name}
                        gridEntityType={gridEntityType}
                        config={createButtonConfig}
                        controllerUrl={controllerUrl}
                        setPopupConfig={setPopupConfig}
                        setPopupUrl={setPopupUrl}
                        setPopupType={setPopupType}
                        setPopupMode={setPopupMode}
                        setPopupRedirectAfter={setPopupRedirectAfter}
                        setFormPostData={setFormPostData}
                        setPopupGetMethod={setPopupGetMethod}
                        setPopupComponent={setPopupComponent}
                        setPopupComponentProps={setPopupComponentProps}
                        t={t}
                        id={`grid_${gridName}_buttons_${createButtonConfig.name}_button`}
                        form={form}
                    />
                );
            });
        }
    };

    return (
        <Grid
            container
            alignContent={'center'}
            justifyContent={'center'}
            sx={{ width: '100%', height: height ? '80vh' : '200px' }}
        >
            <Stack alignItems={'center'} spacing={2}>
                <IconMi
                    icon={emptyIcon ?? 'template'}
                    sx={{ fontSize: '32px', color: (theme: Theme) => alpha(theme.palette.text.primary, 0.24) }}
                />
                <Typography>{emptyTitle}</Typography>
                <Stack direction={'row'} spacing={1}>
                    {getCreateButtons()}
                </Stack>
            </Stack>
            {gridPopup}
        </Grid>
    );
}
